import { http } from '@/app/lib/http/client'

export type NotificationType = 'CRITICA' | 'INFORMATIVA'
export type NotificationStatus = 'all' | 'unread' | 'read'

export interface UserNotification {
  id: number
  user_id: number
  type: NotificationType
  module: string | null
  is_redirectable: boolean
  title: string
  description: string | null
  details: {
    redirect_path?: string
    [key: string]: unknown
  } | null
  viewed_at: string | null
  created_at: string
  updated_at: string
}

export interface NotificationPage {
  data: UserNotification[]
  total: number
  current_page: number
  last_page: number
  per_page: number
}

export interface NotificationFilters {
  page?: number
  per_page?: number
  status?: Exclude<NotificationStatus, 'all'>
  type?: NotificationType
  module?: string
}

export const notificationService = {
  async getNotifications(filters: NotificationFilters = {}) {
    const response = await http.get('/notifications', { params: filters })
    return response.data.data as NotificationPage
  },

  async getUnreadCount() {
    const response = await http.get('/notifications/unread-count')
    return response.data.data.count as number
  },

  async markAsViewed(id: number) {
    const response = await http.post(`/notifications/${id}/view`)
    return response.data.data as UserNotification
  },

  async markAllAsViewed() {
    const response = await http.post('/notifications/view-all')
    return response.data.data as { updated: number }
  },

  async deleteNotification(id: number) {
    const response = await http.delete(`/notifications/${id}`)
    return response.data
  },
}
